export default "__VITE_ASSET__DyheZQwl__"